/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const NotificationIcon = ({size, ...props}) => (
  <svg viewBox="0 0 6 6" fill="currentColor" width={ size || "6" } height={ size || "6" } {...props}>
    <circle cx="3" cy="12" r="3" transform="translate(0 -9)" fill="#EA5F0E" fillRule="evenodd" />
  </svg>
);
NotificationIcon.displayName = 'NotificationIcon';
NotificationIcon.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
